var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGoogle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 497.874 497.874",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.703 34.244c-43.695-25.228-99.479-10.286-124.711 33.417L12.394 338.895c-40.412 69.995 24.347 154.827 102.692 133.831 23.555-6.312 43.242-21.418 55.435-42.537l156.597-271.235c25.171-43.594 10.18-99.54-33.415-124.71z",
    fill: "#FBBE3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.642 360.913c-13.058-48.734-63.067-77.617-111.813-64.555-78.373 21-91.981 126.853-22.018 167.248 69.801 40.3 154.944-23.895 133.831-102.693z",
    fill: "#FBBE3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M485.661 338.895L329.063 67.661c-12.192-21.119-31.88-36.225-55.435-42.537-78.369-21.003-143.086 63.867-102.692 133.831L327.534 430.19c25.221 43.685 81 58.654 124.711 33.417 43.595-25.171 58.586-81.116 33.416-124.712z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.642 360.913c-13.058-48.734-63.067-77.617-111.813-64.555-78.373 21-91.981 126.853-22.018 167.248 69.801 40.3 154.944-23.895 133.831-102.693z",
    fill: "#41a853"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.2873116c.svg";
export { ForwardRef as ReactComponent };